import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { publicSvgPath, publicImagePath } from '../../utils/constants';

export default makeStyles((theme: Theme) => ({
  gradientBG: {
    backgroundColor: theme.palette.primary.dark,
  },
  gradientGrey: {
    background: 'linear-gradient(0deg, rgba(0, 10, 140, 0.1), rgba(0, 10, 140, 0.1)), #FFFFFF',
  },
  imageBG: {
    overflowX: 'hidden',
    backgroundImage: `url(${publicSvgPath}/backgroundBtn/pattern.png) !important`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
  },
  imageBG2: {
    minHeight: '95vh',
    backgroundAttachment: 'fixed',
    backgroundImage: `url(${publicSvgPath}/backgroundBtn/pattern2.png) !important`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
    '@media only screen and (max-width: 600px)': {
      backgroundColor: '#0E1247 !important',
      backgroundImage: 'none !important',
    },
    '@media only screen and (max-width: 361px)': {
      backgroundColor: '#0E1247 !important',
      backgroundImage: 'none !important',
    },
  },
  bgWhite: {
    background: 'linear-gradient(0deg, rgba(0, 10, 140, 0.1), rgba(0, 10, 140, 0.1)), #FFFFFF',
  },
  noPadding: {
    '&>div': {
      '@media(min-width: 1250px)': {
        padding: '0px !important',
      },
      '@media only screen and (max-width: 600px)': {
        paddingLeft: '0px !important',
        paddingRight: '0px !important',
      },
    },
  },
  layout: {
    width: '100%',
    minHeight: '100vh',
    overflow: 'visible',
    overflowX: 'hidden',
    overflowY: 'hidden',
  },
  content: {
    minHeight: '100vh',
    color: theme.palette.primary.main,
    overflow: 'visible',
    zIndex: 1,
  },
  transparentBg: {
    backgroundColor: 'transparent !important',
    position: 'relative',
  },
  bgV2: {
    backgroundColor: '#F7F7FB',
    backgroundImage: 'url(/images/Background/background_test_v2.svg)',
    backgroundSize: 'cover',
    backgroundPosition: '0 0',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed',
    width: '100% !important',
    maxWidth: '100% !important',
    minHeight: '100vh',
    overflowX: 'hidden' as any,
    '@media only screen and (max-width: 600px)': {
      backgroundImage: 'none',
      backgroundColor: '#fff',
    },
  },
  appBar: {
    paddingRight: theme.spacing(3),
    color: theme.palette.primary.main,
    backgroundColor: '#fff',
    border: '1px solid #E3E8F0',
    '&>button': {
      marginRight: theme.spacing(-2),
    },
    [theme.breakpoints.down('sm')]: {
      paddingRight: theme.spacing(0),
    },
  },
  navbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 10,
    marginBottom: 10,
    height: 56,
    '& a': {
      marginRight: theme.spacing(4.75),
    },
    [theme.breakpoints.down('sm')]: {
      height: '100%',
      width: '98.5%',
      margin: '20 auto',
    },
  },
  logoImg: {
    width: '100%',
    height: 'auto',
  },
  navbarWithoutLogo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 56,
    '& a': {
      marginRight: theme.spacing(4.75),
    },
    '@media(min-width: 1250px)': {
      height: 76,
    },
  },
  logoContainer: {
    cursor: 'pointer',
    maxWidth: 239,
    marginLeft: 20,
    [theme.breakpoints.down('sm')]: {
      maxWidth: 160,
      marginTop: 5,
      marginLeft: 10,
    },
  },
  logo: {
    width: '100%',
    height: 'auto',
  },
  profilContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  burgerMenu: {
    '& div, hr': {
      marginLeft: '0px !important',
      '@media(min-width: 1250px)': {
        marginLeft: '0px !important',
      },
    },
  },
  btnPrimary: {
    minHeight: 38,
    height: 38,
    width: 38,
    minWidth: 38,
    textTransform: 'none',
    background:
      'transparent linear-gradient(230deg, #FFDC27 0%, #E63C3C 50%, #000A8C 100%) 0% 0% no-repeat padding-box',
    color: '#fff',
    '@media(min-width: 600px)': {
      minHeight: 48,
      height: 48,
      width: 146,
      minWidth: 146,
    },
  },
  initial: {
    width: 38,
    height: 38,
    background: '#000A8C 0% 0% no-repeat padding-box',
    borderRadius: '100%',
    color: '#fff',
    fontSize: 16,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& span': {
      height: '51%',
    },
  },
  divider: {
    display: 'none',
    '@media(min-width: 1250px)': {
      display: 'block',
      height: '20px',
      marginTop: 'auto',
      marginBottom: 'auto',
    },
  },
  textHeader: {
    display: 'none',
    marginLeft: 0,
    '@media(min-width: 600px)': {
      display: 'block',
    },
  },
  profile: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 !important',
    cursor: 'pointer',
    '& > span': {
      marginLeft: 10,
      '@media(min-width: 1250px)': {
        marginLeft: 10,
      },
    },
  },
  buttonBack: {
    display: 'flex',
    background: '#000a8c47',
    color: '#000A8C',
    height: '100%',
    width: '135px',
    borderRadius: '0px !important',
    '&: hover': {
      background: '#000a8c47',
      color: '#000A8C',
    },
  },
  btnWhite: {
    backgroundColor: '#fff#',
    color: '#0E1247',
    marginTop: 0,
    marginRight: 5,
    borderRadius: 3,
    opacity: 1,
    border: 'solid grey',
    textTransform: 'none',
    minHeight: 48,
    minWidth: 146,
    [theme.breakpoints.down('sm')]: {
      padding: '1vh',
      minHeight: 48,
      height: 48,
      width: 140,
      minWidth: 130,
    },
  },
  topLineContainer: {
    position: 'fixed',
    top: 71,
    right: 0,
    backgroundImage: `url(${publicSvgPath}/backgroundBtn/top_line.svg)`,
    backgroundRepeat: 'no-repeat',
    width: 611,
    height: 574,
    zIndex: 0,
    [theme.breakpoints.down('md')]: {
      top: -64,
      right: -142,
    },
    [theme.breakpoints.down('sm')]: {
      top: -83,
      right: -142,
    },
    [theme.breakpoints.down('xs')]: {
      backgroundImage: `url(${publicSvgPath}/backgroundBtn/top_line_mobile.svg)`,
      backgroundRepeat: 'no-repeat',
      top: 60,
      right: -236,
    },
  },
  bottomLineContainer: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    backgroundImage: `url(${publicSvgPath}/backgroundBtn/bottom_line.svg)`,
    backgroundRepeat: 'no-repeat',
    width: 601,
    height: 463,
    zIndex: 0,
    [theme.breakpoints.down('md')]: {
      bottom: -35,
      left: -135,
    },
    [theme.breakpoints.down('xs')]: {
      backgroundImage: `url(${publicSvgPath}/backgroundBtn/bottom_line_mobile.svg)`,
      bottom: -167,
      left: 0,
    },
  },
  imageBG3: {
    background: `url(${publicSvgPath}/fond_homepage.png), #0E1444`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% auto',
    backgroundPosition: '0% 0%',
    '@media only screen and (max-width: 600px)': {
      background: `url(${publicSvgPath}/fond_transparent_mobile_accueil.png), #0E1444`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% auto',
      backgroundPosition: '0% 0%',
    },
    '@media only screen and (max-width: 361px)': {
      background: `url(${publicSvgPath}/fond_transparent_mobile_accueil.png), #0E1444`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% auto',
      backgroundPosition: '0% 0%',
    },
  },
}));
